// src/i18n/en/views/iframes.js
export const iframes = {
  pricing: {
    title: "Calculateur de tarifs",
    description:
      "Configurez les prix de base et les suppléments par unité pour chaque plan ; les factures affichent la taxe sur une ligne distincte.",
    src: "https://player.vimeo.com/video/00000001",
    ariaLabel: "Vidéo : Calculateur de tarifs (EN)",
  },
  connectBooking: {
    title: "Connecter Booking.com",
    description:
      "Guide étape par étape pour relier votre propriété à Booking.com via le Channel Manager.",
    src: "https://player.vimeo.com/video/00000002",
    ariaLabel: "Vidéo : Connecter Booking.com (EN)",
  },
  connectAirbnb: {
    title: "Connecter Airbnb (via Channex)",
    description:
      "Activez la connexion Airbnb depuis votre PMS à l'aide de Channex et synchronisez la disponibilité et les tarifs.",
    src: "https://player.vimeo.com/video/00000003",
    ariaLabel: "Vidéo : Connecter Airbnb (EN)",
  },
  channexCertification: {
    title: "Certification Channex · PMS",
    description:
      "Exigences et tests pour valider la certification PMS avec Channex (synchronisation complète, tarifs, restrictions).",
    src: "https://player.vimeo.com/video/00000004",
    ariaLabel: "Vidéo : Certification Channex (EN)",
  },
  hotelCalendar: {
    title: "Calendrier hôtelier (multichambre)",
    description:
      "Gérez les réservations par type de chambre et par instance ; évitez les surréservations grâce à une vue structurée.",
    src: "https://player.vimeo.com/video/00000005",
    ariaLabel: "Vidéo : Calendrier hôtelier (EN)",
  },
  apartmentCalendar: {
    title: "Calendrier des appartements",
    description:
      "Blocages, prix par jour et séjours dans un calendrier par propriété.",
    src: "https://player.vimeo.com/video/00000006",
    ariaLabel: "Vidéo : Calendrier des appartements (EN)",
  },
  guestCheckin: {
    title: "Check-in WhatsApp",
    description:
      "Les clients scannent leur pièce d'identité, passent la vérification d'identité et signent numériquement depuis leur téléphone.",
    src: "https://player.vimeo.com/video/00000007",
    ariaLabel: "Vidéo : Check-in WhatsApp (EN)",
  },
  identityVerification: {
    title: "Vérification d'identité et signature électronique",
    description:
      "Contrôle par selfie, lecture MRZ/PDF417 et signature électronique sécurisée pour la conformité.",
    src: "https://player.vimeo.com/video/00000008",
    ariaLabel: "Vidéo : Vérification d'identité (EN)",
  },
  smartLocks: {
    title: "Serrures connectées",
    description:
      "Envoyez des codes d'accès automatiques, sans clés ni attente. Prend en charge les codes dynamiques.",
    src: "https://player.vimeo.com/video/00000009",
    ariaLabel: "Vidéo : Serrures connectées (EN)",
  },
  reviewsAutomation: {
    title: "Automatisation des avis",
    description:
      "Planifiez des rappels d'avis et développez la réputation de votre propriété.",
    src: "https://player.vimeo.com/video/00000010",
    ariaLabel: "Vidéo : Automatisation des avis (EN)",
  },
};
